module.exports = __webpack_public_path__ + "static/media/gutgereift_logo_original.970b0236.svg";